export default __webpack_public_path__ + "static/media/photo--lg--group-2.58913f8c.jpg";